import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import Home from './components/Home';
import OurStory from './components/OurStory';
import WeddingDetails from './components/WeddingDetails';
import Gallery from './components/Gallery';
import Footer from './components/Footer';
import Gift from './components/Gift';
import ThemeToggle from './components/ThemeToggle';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <ThemeToggle />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/our-story" element={<OurStory />} />
          <Route path="/wedding-details" element={<WeddingDetails />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/presente" element={<Gift />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
